import {createActions, handleActions} from 'redux-actions';

export const actions = createActions({}, 'SESSION_SET', 'SESSION_CLEAR');

/**
 * Manage dirty state state.
 *
 * Keep track of keys that specify which items are dirty (assuming more than one thing can be dirty at a time).
 */
export const reducer = handleActions({
	[actions.sessionSet]: (state, {payload}) => ({
		...payload
	}),
	[actions.sessionClear]: () => null
}, null);


// WEBPACK FOOTER //
// ./src/session.state.js